var _circle, _circle2, _circle3, _circle4, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoTransactionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 118,
    viewBox: "0 0 118 118",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 59,
    cy: 59,
    r: 59,
    fill: "#21B55A",
    fillOpacity: 0.06
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 58.9998,
    cy: 59.2933,
    r: 35.8997,
    fill: "#E9F8EF"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 58.9998,
    cy: 59.2937,
    r: 39.9814,
    fill: "#E9F8EF",
    stroke: "white",
    strokeWidth: 2.22634
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_99_28071",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 20,
    width: 78,
    height: 78
  }, _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 59,
    cy: 59.293,
    r: 38.6827,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_99_28071)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_99_28071)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.2471 59.1672C80.2471 60.8306 80.0257 62.4939 79.6935 64.0464C79.4721 65.0444 79.14 65.9315 78.8079 66.8186C76.7044 72.363 72.2761 76.7986 66.7407 78.9055C66.2979 79.0164 65.9658 79.2382 65.523 79.349C63.4195 80.0144 61.3161 80.347 58.9912 80.347C47.2562 80.347 37.7354 70.8106 37.7354 59.0563C37.7354 47.3021 47.2562 37.7656 58.9912 37.7656C70.7262 37.8765 80.2471 47.413 80.2471 59.1672Z",
    fill: "url(#paint0_linear_99_28071)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.4015 78.864L65.3867 78.8677L65.3722 78.8723C63.3177 79.5222 61.2651 79.847 58.9912 79.847C47.5331 79.847 38.2354 70.5352 38.2354 59.0563C38.2354 47.5782 47.5318 38.2669 58.9888 38.2656C70.4505 38.3752 79.7471 47.69 79.7471 59.1672C79.7471 60.7868 79.5314 62.4136 79.205 63.9398C78.9924 64.8975 78.6731 65.7524 78.34 66.6422C76.2903 72.0441 71.9781 76.3684 66.589 78.4282C66.3412 78.4932 66.1264 78.5855 65.9462 78.6628L65.9346 78.6678C65.7368 78.7527 65.5783 78.8197 65.4015 78.864Z",
    stroke: "#E8EBEA"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_99_28071",
    x: 29.7354,
    y: 34.7656,
    width: 58.5117,
    height: 58.5811,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.490196 0 0 0 0 0.113725 0 0 0 0 0.658824 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_99_28071"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_99_28071",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_99_28071",
    x1: 39.8212,
    y1: 37.7656,
    x2: 116.475,
    y2: 52.1209,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#21B55A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E4F27"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoTransactionIcon);
export default __webpack_public_path__ + "static/media/no-transaction-icon.812ed4847758af21f08640a055ce73b1.svg";
export { ForwardRef as ReactComponent };